import React, { HTMLAttributes } from 'react'
import styled from 'styled-components'

const SContainer = styled.div`
  margin: 0 auto;
  max-width: ${props => props.theme.general.containerWidth};
  padding: ${props => props.theme.general.containerPadding};
`

const Container: React.FC<HTMLAttributes<HTMLDivElement>> = ({children, ...rest}) => {
  return <SContainer {...rest}>{children}</SContainer>
}

export default Container